const adresaSchema = {
   judet: "",
   localitate: "",
   tipStrada: "",
   strada: "",
   numar: "",
   bloc: "",
   scara: "",
   etaj: "",
   apartament: "",
   codPostal: "",
   codSIRUTA: "",
};

const indexLuniSchemaEmpty = {
   ianuarie: "",
   februarie: "",
   martie: "",
   aprilie: "",
   mai: "",
   iunie: "",
   iulie: "",
   august: "",
   septembrie: "",
   octombrie: "",
   noiembrie: "",
   decembrie: "",
};
const indexLuniSchemaC1 = {
   ianuarie: "200",
   februarie: "200",
   martie: "100",
   aprilie: "100",
   mai: "50",
   iunie: "10",
   iulie: "10",
   august: "10",
   septembrie: "20",
   octombrie: "100",
   noiembrie: "150",
   decembrie: "200",
};
const indexLuniSchemaC2 = {
   ianuarie: "7500",
   februarie: "7500",
   martie: "6350",
   aprilie: "4800",
   mai: "950",
   iunie: "650",
   iulie: "700",
   august: "700",
   septembrie: "700",
   octombrie: "1800",
   noiembrie: "5700",
   decembrie: "6600",
};
const indexLuniSchemaC3 = {
   ianuarie: "40000",
   februarie: "40000",
   martie: "40000",
   aprilie: "40000",
   mai: "40000",
   iunie: "40000",
   iulie: "40000",
   august: "40000",
   septembrie: "40000",
   octombrie: "40000",
   noiembrie: "40000",
   decembrie: "40000",
};

const row1 = ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie"];
const row2 = ["iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"];

const calitatiDetinator = [
   { value: "proprietar", label: "Proprietar" },
   { value: "coproprietar", label: "Co-Proprietar" },
   { value: "chirias", label: "Chiriaș" },
   { value: "uzufruct", label: "Uzufruct/Beneficiar al dreptului de abitație" },
   { value: "unicMostenitor", label: "Unic moștenitor" },
   { value: "comostenitor", label: "Co-moștenitor" },
   { value: "sotSupravietuitor", label: "Soț supraviețuitor" },
   { value: "comodator", label: "Comodator" },
   { value: "alteCazuri", label: "Alte cazuri" },
];

const categoriiConsum = [
   { value: "C1", label: "C1 - consum anual ≤ 280 MWh" },
   { value: "C2", label: "C2 - consum anual > 280 și ≤ 2.800 MWh" },
   { value: "C3", label: "C3 - consum anual > 2.800 și ≤ 28.000 MWh" },
];

const operatoriCLC = [
   "ADS",
   "CON",
   "CGZ",
   "CPL",
   "DEG",
   "DZP",
   "DGS",
   "DGV",
   "ESV",
   "GVS",
   "GNE",
   "GZV",
   "GZM",
   "HRG",
   "ICC",
   "MMD",
   "MGZ",
   "MGA",
   "MHG",
   "MHC",
   "NGZ",
   "NPG",
   "OLG",
   "PEY",
   "PRI",
   "PRG",
   "RGZ",
   "SLG",
   "TLG",
];

const countriesOptions = [
   { value: "Afganistan", label: "Afganistan" },
   { value: "Africa de Sud", label: "Africa de Sud" },
   { value: "Albania", label: "Albania" },
   { value: "Algeria", label: "Algeria" },
   { value: "Andorra", label: "Andorra" },
   { value: "Angola", label: "Angola" },
   { value: "Antigua si Barbuda", label: "Antigua si Barbuda" },
   { value: "Arabia Saudita", label: "Arabia Saudita" },
   { value: "Argentina", label: "Argentina" },
   { value: "Armenia", label: "Armenia" },
   { value: "Australia", label: "Australia" },
   { value: "Austria", label: "Austria" },
   { value: "Azerbaidjan", label: "Azerbaidjan" },
   { value: "Bahamas", label: "Bahamas" },
   { value: "Bahrain", label: "Bahrain" },
   { value: "Bangladesh", label: "Bangladesh" },
   { value: "Barbados", label: "Barbados" },
   { value: "Belarus", label: "Belarus" },
   { value: "Belgia", label: "Belgia" },
   { value: "Belize", label: "Belize" },
   { value: "Benin", label: "Benin" },
   { value: "Bhutan", label: "Bhutan" },
   { value: "Bolivia", label: "Bolivia" },
   { value: "Bosnia si Hertegovina", label: "Bosnia si Hertegovina" },
   { value: "Botswana", label: "Botswana" },
   { value: "Brazilia", label: "Brazilia" },
   { value: "Brunei", label: "Brunei" },
   { value: "Bulgaria", label: "Bulgaria" },
   { value: "Burkina Faso", label: "Burkina Faso" },
   { value: "Burundi", label: "Burundi" },
   { value: "Cambodgia", label: "Cambodgia" },
   { value: "Camerun", label: "Camerun" },
   { value: "Canada", label: "Canada" },
   { value: "Ciad", label: "Ciad" },
   { value: "Chile", label: "Chile" },
   { value: "China", label: "China" },
   { value: "Cipru", label: "Cipru" },
   { value: "Columbia", label: "Columbia" },
   { value: "Comore", label: "Comore" },
   { value: "Congo", label: "Congo" },
   { value: "Coreea de Nord", label: "Coreea de Nord" },
   { value: "Coreea de Sud", label: "Coreea de Sud" },
   { value: "Costa Rica", label: "Costa Rica" },
   { value: "Croatia", label: "Croatia" },
   { value: "Cuba", label: "Cuba" },
   { value: "Danemarca", label: "Danemarca" },
   { value: "Djibouti", label: "Djibouti" },
   { value: "Dominica", label: "Dominica" },
   { value: "Ecuador", label: "Ecuador" },
   { value: "Egipt", label: "Egipt" },
   { value: "El Salvador", label: "El Salvador" },
   { value: "Elvetia", label: "Elvetia" },
   { value: "Emiratele Arabe Unite", label: "Emiratele Arabe Unite" },
   { value: "Eritreea", label: "Eritreea" },
   { value: "Estonia", label: "Estonia" },
   { value: "Eswatini", label: "Eswatini" },
   { value: "Etiopia", label: "Etiopia" },
   { value: "Federația Sfântul Kitts și Nevis", label: "Federația Sfântul Kitts și Nevis" },
   { value: "Fiji", label: "Fiji" },
   { value: "Filipine", label: "Filipine" },
   { value: "Finlanda", label: "Finlanda" },
   { value: "Franta", label: "Franta" },
   { value: "Gabon", label: "Gabon" },
   { value: "Gambia", label: "Gambia" },
   { value: "Georgia", label: "Georgia" },
   { value: "Germania", label: "Germania" },
   { value: "Ghana", label: "Ghana" },
   { value: "Grecia", label: "Grecia" },
   { value: "Grenada", label: "Grenada" },
   { value: "Guatemala", label: "Guatemala" },
   { value: "Guineea-Bissau", label: "Guineea-Bissau" },
   { value: "Guinea", label: "Guinea" },
   { value: "Guineea Ecuatoriala", label: "Guineea Ecuatoriala" },
   { value: "Guyana", label: "Guyana" },
   { value: "Haiti", label: "Haiti" },
   { value: "Honduras", label: "Honduras" },
   { value: "India", label: "India" },
   { value: "Indonezia", label: "Indonezia" },
   { value: "Insulele Solomon", label: "Insulele Solomon" },
   { value: "Insulele Marshall", label: "Insulele Marshall" },
   { value: "Iordania", label: "Iordania" },
   { value: "Irak", label: "Irak" },
   { value: "Iran", label: "Iran" },
   { value: "Irlanda", label: "Irlanda" },
   { value: "Islanda", label: "Islanda" },
   { value: "Israel", label: "Israel" },
   { value: "Italia", label: "Italia" },
   { value: "Jamaica", label: "Jamaica" },
   { value: "Japonia", label: "Japonia" },
   { value: "Kirghizstan", label: "Kirghizstan" },
   { value: "Kazahstan", label: "Kazahstan" },
   { value: "Kenya", label: "Kenya" },
   { value: "Kiribati", label: "Kiribati" },
   { value: "Kuweit", label: "Kuweit" },
   { value: "Laos", label: "Laos" },
   { value: "Lesotho", label: "Lesotho" },
   { value: "Letonia", label: "Letonia" },
   { value: "Liban", label: "Liban" },
   { value: "Liberia", label: "Liberia" },
   { value: "Libia", label: "Libia" },
   { value: "Liechtenstein", label: "Liechtenstein" },
   { value: "Lituania", label: "Lituania" },
   { value: "Luxembourg", label: "Luxembourg" },
   { value: "Macedonia de Nord", label: "Macedonia de Nord" },
   { value: "Madagascar", label: "Madagascar" },
   { value: "Malaezia", label: "Malaezia" },
   { value: "Malawi", label: "Malawi" },
   { value: "Maldive", label: "Maldive" },
   { value: "Mali", label: "Mali" },
   { value: "Malta", label: "Malta" },
   { value: "Marea Britanie", label: "Marea Britanie" },
   { value: "Maroc", label: "Maroc" },
   { value: "Mauritania", label: "Mauritania" },
   { value: "Mauritius", label: "Mauritius" },
   { value: "Mexic", label: "Mexic" },
   { value: "Micronezia", label: "Micronezia" },
   { value: "Moldova", label: "Moldova" },
   { value: "Monaco", label: "Monaco" },
   { value: "Mongolia", label: "Mongolia" },
   { value: "Mozambic", label: "Mozambic" },
   { value: "Muntenegru", label: "Muntenegru" },
   { value: "Myanmar", label: "Myanmar" },
   { value: "Namibia", label: "Namibia" },
   { value: "Nauru", label: "Nauru" },
   { value: "Nepal", label: "Nepal" },
   { value: "Nicaragua", label: "Nicaragua" },
   { value: "Nigeria", label: "Nigeria" },
   { value: "Norvegia", label: "Norvegia" },
   { value: "Noua Zeelanda", label: "Noua Zeelanda" },
   { value: "Olanda", label: "Olanda" },
   { value: "Oman", label: "Oman" },
   { value: "Pakistan", label: "Pakistan" },
   { value: "Palau", label: "Palau" },
   { value: "Palestina", label: "Palestina" },
   { value: "Panama", label: "Panama" },
   { value: "Papua Noua Guineea", label: "Papua Noua Guineea" },
   { value: "Paraguay", label: "Paraguay" },
   { value: "Peru", label: "Peru" },
   { value: "Polonia", label: "Polonia" },
   { value: "Portugalia", label: "Portugalia" },
   { value: "Qatar", label: "Qatar" },
   { value: "Republica Capului Verde", label: "Republica Capului Verde" },
   { value: "Republica Ceha", label: "Republica Ceha" },
   { value: "Republica Central Africana", label: "Republica Central Africana" },
   { value: "Republica Coasta de Fildes", label: "Republica Coasta de Fildes" },
   { value: "Republica Democratica Congo", label: "Republica Democratica Congo" },
   { value: "Republica Dominicana", label: "Republica Dominicana" },
   { value: "Romania", label: "Romania" },
   { value: "Rusia", label: "Rusia" },
   { value: "Rwanda", label: "Rwanda" },
   { value: "Samoa", label: "Samoa" },
   { value: "San Marino", label: "San Marino" },
   { value: "Santa Lucia", label: "Santa Lucia" },
   { value: "Senegal", label: "Senegal" },
   { value: "Serbia", label: "Serbia" },
   { value: "Seychelles", label: "Seychelles" },
   { value: "Sierra Leone", label: "Sierra Leone" },
   { value: "Singapore", label: "Singapore" },
   { value: "Siria", label: "Siria" },
   { value: "Slovacia", label: "Slovacia" },
   { value: "Slovenia", label: "Slovenia" },
   { value: "Somalia", label: "Somalia" },
   { value: "Spania", label: "Spania" },
   { value: "Sri Lanka", label: "Sri Lanka" },
   { value: "Statele Unite ale Americii", label: "Statele Unite ale Americii" },
   { value: "Sudan", label: "Sudan" },
   { value: "Sudanul de Sud", label: "Sudanul de Sud" },
   { value: "Suedia", label: "Suedia" },
   { value: "Surinam", label: "Surinam" },
   { value: "Tajikistan", label: "Tajikistan" },
   { value: "Tanzania", label: "Tanzania" },
   { value: "Thailanda", label: "Thailanda" },
   { value: "Timorul de Est", label: "Timorul de Est" },
   { value: "Togo", label: "Togo" },
   { value: "Tonga", label: "Tonga" },
   { value: "Trinidad-Tobago", label: "Trinidad-Tobago" },
   { value: "Tunisia", label: "Tunisia" },
   { value: "Turcia", label: "Turcia" },
   { value: "Turkmenistan", label: "Turkmenistan" },
   { value: "Tuvalu", label: "Tuvalu" },
   { value: "Ucraina", label: "Ucraina" },
   { value: "Uganda", label: "Uganda" },
   { value: "Ungaria", label: "Ungaria" },
   { value: "Uruguay", label: "Uruguay" },
   { value: "Uzbekistan", label: "Uzbekistan" },
   { value: "Vanuatu", label: "Vanuatu" },
   { value: "Vatican", label: "Vatican" },
   { value: "Venezuela", label: "Venezuela" },
   { value: "Vietnam", label: "Vietnam" },
   { value: "Yemen", label: "Yemen" },
   { value: "Zambia", label: "Zambia" },
   { value: "Zimbabwe", label: "Zimbabwe" },
];

const objectsSchema = {
   adresaSchema,
   indexLuniSchemaEmpty,
   indexLuniSchemaC1,
   indexLuniSchemaC2,
   indexLuniSchemaC3,
   row1,
   row2,
   calitatiDetinator,
   categoriiConsum,
   operatoriCLC,
   countriesOptions,
};

export default objectsSchema;
